import { ContainerComponent, wrap } from 'AppReact';
import { Button } from './atoms';
import Controller from './controller'
import internalState from './internalState';
import { Wrapper } from './wrappers';

export const definition = {
  name: 'TextSwitchButton',
  controller: Controller,
  initialProps: ({ leftValue, rightValue, selectedValueId }) => ({ leftValue, rightValue, selectedValueId }),
  props: internalState,
  elements: [
    {
      wrapper: Wrapper,
      name: '__transparent__',
      elements: [
        {
          component: Button,
          name: 'LeftButton',
          bindings: ({ selectedValueId, leftValue }) => ({ selectedValueId, leftValue }),
          displayState: ({ selectedValueId, leftValue }) => ({ selected: selectedValueId === leftValue.id }),
          displayValue: ({ leftValue }) => leftValue.display,
        },
        {
          component: Button,
          name: 'RightButton',
          bindings: ({ selectedValueId, rightValue }) => ({ selectedValueId, rightValue }),
          displayState: ({ selectedValueId, rightValue }) => ({ selected: selectedValueId === rightValue.id }),
          displayValue: ({ rightValue }) => rightValue.display,
        }
      ]
    }
  ]
}

export default ContainerComponent(definition);